export function isHttpUrl(value?: string | null): value is string {
  if (!value) return false;
  return /^https?:\/\//i.test(value.trim());
}
